import { all, takeEvery, put, fork, call } from 'redux-saga/effects';
import actions from './actions';

export function* getSettings() {
    yield takeEvery(actions.FETCH_SETTINGS_REQUESTED, function* (action) {
        try {
          const settings = yield call(actions.getSettings, action.payload);
          yield put({ type: actions.FETCH_SETTINGS_SUCCEEDED, settings });
        } catch (error) {
          yield put({ type: actions.FETCH_SETTINGS_FAILED, error: error.message });
        }
    });
}

export function* updateSettings() {
    yield takeEvery(actions.UPDATE_SETTINGS_REQUESTED, function* (action) {
        try {
            const settings = yield call(actions.updateSettingsData, action.payload);
            yield put({ type: actions.UPDATE_SETTINGS_SUCCEEDED, settings: settings?.setting_info });
        } catch (error) {
            yield put({ type: actions.UPDATE_SETTINGS_FAILED, error: error.response?.data });
        }
    });
}

export default function* rootSaga() {
    yield all([
        fork(getSettings),
        fork(updateSettings),
    ]);
}
